import { initSubRoutes } from '../../../../utils/router';

const RoutesDemanderImpression = initSubRoutes({
    route: '/demander-impression',
    subroutes: {},
    nom: "Demander l'impression de son ratelier",
});

export default RoutesDemanderImpression;
